import { Component, OnInit } from '@angular/core';
import { MoreInfoData } from './more-info-data';


@Component({
  templateUrl: './more-info.component.html',
  styleUrls: ['./more-info.component.scss']
})
export class NecMoreInfoComponent implements OnInit {
  moreInfoData: MoreInfoData[];

  constructor() {
  }

  ngOnInit() {
    this.moreInfoData = [new MoreInfoData(
      'è¿éææ¤å£«æå­¦éè¦çä¸å',
      'äº¬é¢â512èè¯æè²ç½âæä¾äºå¨æ°çæ¤å£«å¨é¢æå­¦æ¨¡å¼ï¼å¯è¿è¡é«æçæ¤çå¹è®­ä¸èè¯ãéè¿512èè¯æè²ç½ï¼å¯ä»¥ä½¿æ¤å£«æå­¦è®¡åãå¹è®­ãèè¯ãåæãåé¦çæµç¨å½¢æå®æ´é­ç¯',
      'assets/images/common/home/more-info/all-modules.png'
    ), new MoreInfoData(
      'å¨çº¿è¯¾ç¨ï¼ä¸ä¸æ ·çæ¤å£«å¹è®­è§£å³æ¹æ¡',
      'å©ç¨âç¿»è½¬è¯¾å âãâå¾®è¯¾ç¨âç­çº¿ä¸çº¿ä¸ç¸ç»åçå¹è®­å½¢å¼ï¼åä»£åçº¯ççº¿ä¸éä¸­å¹è®­ï¼ä½¿å»é¢æ¤å£«å¹è®­æç ´äºæ¶é´åç©ºé´çéå¶ï¼å¹¶ä¸ºç®¡çäººåæä¾è¿ç¨çæ§åç»æåæ',
      'assets/images/common/home/more-info/online-course.png'
    ), new MoreInfoData(
      'èè¯åºé¢ãç»ç»ãåæãå¯¹æ¯ï¼é½ä¸åæ¯éç¢',
      'ä»¥å¨çº¿èè¯çå½¢å¼ï¼å¸®å©ç®¡çäººåå®æè¯å·çæãèè¯éç¥ãèªå¨æ¹éãç»æåæãæ¨ªåå¯¹æ¯çå¨æµç¨ï¼æçåä¾¿æ·æ§é½å¾å°å¤§å¹ä¸å',
      'assets/images/common/home/more-info/question.png'
    ), new MoreInfoData(
      'é¢åç§¯åï¼å¨æ°çæ¤å£«æå­¦ç®¡çæè·¯',
      'é¦æ¬¡æåºæ¤çäººåé¢åå­¦ä¹ ç§¯åæ¦å¿µï¼ä»¥âé¢åå­¦åâä¸ºä¸»çº¿ï¼è´¯ç©¿å¹è®­å·¥ä½è®¡åãå®æ½ãè¿ç¨çç£ãææä½éªçåä¸ªç¯è',
      'assets/images/common/home/more-info/chart-report.png'
    ), new MoreInfoData(
      'ä¸ç®äºç¶ï¼ç»æå°±å¨ç¼å',
      'æä¾ä¸ç§ãè½çº§ãèç§°ç­å¤ç»´åº¦çå¹è®­ä¸èè¯æåµç»è®¡ï¼å¸®å©ç®¡çäººåè¿éææ¡å¨å±ï¼å¸®å©æ¤å£«è®°å½èªèº«æé¿è½¨è¿¹',
      'assets/images/common/home/more-info/exam-report.png'
    ), new MoreInfoData(
      'å¤ç»´æ è®°ï¼å¤å±å¹è®­èè¯çå©å¨',
      'ä»¥ç§ç»ãè½çº§ãèç§°è¿è¡äººååç»ï¼ä»¥ä¸ç§ãé¾åº¦ãç¹ç¹éå¯¹åå®¹åç±»ï¼è®©å»é¢åå±å¹è®­èè¯æ´å ä¾¿æ·',
      'assets/images/common/home/more-info/question-bank.png'
    ), new MoreInfoData(
      'æ¹ä¾¿çä¼è´¨èµæºå±äº«',
      'å¯ä»¥åæå®çåäºåäº«ç²¾å¿å¶ä½çè¯¾ä»¶æè§é¢ï¼è®©ä¼è´¨èµæºæ´æ¹ä¾¿å°æµéèµ·æ¥ï¼å±åä¿è¿å¨é¢æ¤çæ°´å¹³çæå',
      'assets/images/common/home/more-info/resource.png'
    )];
  }
}
